import { Route, Routes } from 'react-router-dom';
import { Header } from '@components/index';
import {
  FactoryOn,
  IndustryLandList,
  InnoBiz,
  Login,
  MainBiz,
  Venture,
  MiniCluster
} from './pages';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<Header />}>
        <Route path="/industry" element={<IndustryLandList />} />
      </Route>
      <Route element={<Header />}>
        <Route path="/factoryon" element={<FactoryOn />} />
      </Route>
      <Route element={<Header />}>
        <Route path="/innobiz" element={<InnoBiz />} />
      </Route>
      <Route element={<Header />}>
        <Route path="/mainbiz" element={<MainBiz />} />
      </Route>
      <Route element={<Header />}>
        <Route path="/venture" element={<Venture />} />
      </Route>
      <Route element={<Header />}>
        <Route path="/minicluster" element={<MiniCluster />} />
      </Route>
    </Routes>
  );
};

export default App;
